// Slice 1 (AI agents, knowledge, test lab, branding, hosted chat) — Urdu and Arabic for nav-level and key strings.
export default {
  ur: {
    'agents.new': 'نیا ایجنٹ', 'agents.create': 'ایجنٹ بنائیں', 'agents.created': 'ایجنٹ بن گیا', 'agents.saved': 'ڈرافٹ محفوظ ہو گیا',
    'agents.empty': 'اپنا پہلا اے آئی ایجنٹ بنائیں',
    'knowledge.add': 'معلومات شامل کریں', 'knowledge.empty': 'اپنا پہلا ذریعہ شامل کریں',
    'branding.saved': 'ویجیٹ محفوظ ہو گیا',
    'chat.title': 'چیٹ', 'chat.unavailable': 'چیٹ دستیاب نہیں', 'chat.loadFailed': 'چیٹ لوڈ نہیں ہو سکی۔ کنکشن چیک کر کے دوبارہ کوشش کریں۔',
    'chat.badLink': 'یہ چیٹ لنک درست نہیں۔',
  },
  ar: {
    'agents.new': 'وكيل جديد', 'agents.create': 'إنشاء الوكيل', 'agents.created': 'تم إنشاء الوكيل', 'agents.saved': 'تم حفظ المسودة',
    'agents.empty': 'أنشئ أول وكيل ذكاء اصطناعي',
    'knowledge.add': 'إضافة معرفة', 'knowledge.empty': 'أضف أول مصدر',
    'branding.saved': 'تم حفظ الأداة',
    'chat.title': 'الدردشة', 'chat.unavailable': 'الدردشة غير متاحة', 'chat.loadFailed': 'تعذر تحميل الدردشة. تحقق من اتصالك وحاول مرة أخرى.',
    'chat.badLink': 'رابط الدردشة هذا غير صالح.',
  },
};
